import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <ContactSection />
        <TopicsSection />
        <RankingSection />
        <CommentsSection />
        <AboutSection />
        <IndexSection />
        <AppSection />
        <MediaSection />
        <FaqSection />
        <FeaturesSection />
        <UpdatesSection />
        <CarouselSection />
        <CardsSection />
      </main>
      <Footer />
    </>
  );
}